import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5b58c65e&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b58c65e')) {
      api.createRecord('5b58c65e', component.options)
    } else {
      api.reload('5b58c65e', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=5b58c65e&", function () {
      api.rerender('5b58c65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Library/Builder/App.vue"
export default component.exports